import axios from "axios";
import { getToken, removeToken } from "./setToken.js";
import { Message } from 'element-ui'
import router from '@/router'

const service = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json;'
    },
    timeout: 5000
})

// 添加请求拦截器
service.interceptors.request.use((config) => {
    // 在请求之前需要做的事（例如获取并设置token）
    // 使用标准 Authorization: Bearer 方式（方式A），同时保留兼容老代码的 Token header（方式B）
    const token = getToken('token')
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
        config.headers['Token'] = token
    }
    // 上传文件时不强制设置 Content-Type，让浏览器自动设置 boundary
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type']
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use((response) => {
    // 对响应数据的操作
    let { code, tip } = response.data
    if(code !== 200){
        Message({message: tip || 'error', type: 'warning'})
    }
    return response
}, (error) => {
    // 统一处理安全拦截错误
    if (error.response && error.response.data) {
        const msg = error.response.data.msg || error.response.data.tip || ''
        // Token 无效或过期，强制踢回登录页
        if (msg.includes('未携带Token') || msg.includes('无效的Token') || msg.includes('已过期')) {
            removeToken('token')
            removeToken('username')
            removeToken('is_admin')
            removeToken('custom')
            Message({ message: '登录已过期，请重新登录', type: 'error' })
            router.push('/login')
            return Promise.reject(error)
        }
        // 设备无权访问/操作/删除
        if (msg.includes('无权访问') || msg.includes('无权操作') || msg.includes('无权删除')) {
            Message({ message: msg, type: 'warning' })
            return Promise.reject(error)
        }
    }
    return Promise.reject(error)
})


// // 设置请求次数，请求的间隙
// service.defaults.retry = 4;
// service.defaults.retryDelay = 1000;
 
// // request interceptor
// service.interceptors.request.use(
//   config => {
//     // do something before request is sent
//     return config
//   },
//   error => {
//     // do something with request error
//     // console.log(error) // for debug
//     return Promise.reject(error)
//   }
// )
 
// // response interceptor
// service.interceptors.response.use(
//   response => {
//     const res = response.data
//     return res
//   },
//   error => {
//     if (error.response) {
//       // console.log('err' + error) // for debug
//       switch (error.response.status) {
//         case 401:
//           // console.log('err status' + error.response.status)
//           this.$router.push('/login')
//           break
//         case 404:
//           break
//         case 500:
//           break
//       }
//       return Promise.reject(error)
//     } else {
//       // 处理超时的情况
//       let config = error.config
//       // If config does not exist or the retry option is not set, reject
//       if(!config || !config.retry) return Promise.reject(error)
  
//       // Set the variable for keeping track of the retry count
//       config.__retryCount = config.__retryCount || 0
  
//       // Check if we've maxed out the total number of retries
//       if(config.__retryCount >= config.retry) {
//         // Reject with the error
//         return Promise.reject(error)
//       }
  
//       // Increase the retry count
//       config.__retryCount += 1
  
//       // Create new promise to handle exponential backoff
//       let backoff = new Promise(function(resolve) {
//         setTimeout(function() {
//           resolve()
//         }, config.retryDelay || 1)
//       })
  
//       // Return the promise in which recalls axios to retry the request
//       return backoff.then(function() {
//         return service(config)
//       })
//     }
 
//   }
// )

export default service
